import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import CurrencyFlag from "react-currency-flags";
import Auth from "../../lib/middleware/auth";
import { chooseCurrency, fetchCurrency } from "../../redux/actions/wallet";
import { useMutation, useQuery } from "react-query";
import { Loading } from "..";
import { message, Select } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";

const CurrencyWrapper = styled.span`
	/* ${tw`border border-solid border-appTextFaded  rounded-lg px-0.5 py-1`} */
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;

	.curreny-img {
		height: auto;
		width: 30px;
		padding: 6px;
		background: #dfebf2;
		border-radius: 50%;

		span {
			border-radius: 50%;
			background-position: center;
		}
	}

	.code {
		display: inline-flex;
		align-items: center;
		color: #7a8d9c;
		font-size: 0.875rem;
		font-weight: 700;
		text-transform: uppercase;
	}

	.custom-select {
		border: none;
		padding: 0.375rem;

		&:focus {
			outline: none;
			box-shadow: none;
		}
	}

	@media (max-width: 768px) {
		.currency {
			justify-content: flex-end;
			// margin-top: 10px;

			img {
				height: auto;
				max-width: 20px;
				padding: 4px;
				background: #dfebf2;
				border-radius: 50%;
			}
			.code {
				display: inline-flex;
				align-items: center;
				color: #616669;
				font-weight: 600;
				font-weight: 700;
				font-size: 0.7rem;
			}

			.custom-select {
				border: none;
				padding: 0.375rem;
				&:focus {
					outline: none;
					box-shadow: none;
				}
			}
		}
	}
`;

const Currency = (props) => {
	const { Option } = Select;
	const { hideFlag } = props;
	const { data: currencyData, isLoading } = useQuery(
		"currency",
		fetchCurrency,
		{
			refetchOnWindowFocus: false,
			refetchOnmount: false,
		}
	);
	const currencies = currencyData?.data;
	const currencyObject = Auth.getCurrency();
	const myFlag = currencyObject?.code;
	const [flag, setFlag] = useState(myFlag);

	const { mutateAsync, isLoading: cloading } = useMutation(chooseCurrency);

	// Change default currency
	const handleChange = async (e) => {
		const currencyObject = await Auth.getCurrency();
		const data = {
			currencyId: currencyObject.id,
		};
		try {
			const res = await mutateAsync(data);
			const { hasError } = res;
			if (hasError) {
				return message.error(res.errors.message);
			}
			message.success(`Default currency set to ${currencyObject.code}`);
			window.location.reload(false);
		} catch (error) {}
	};
	return (
		<CurrencyWrapper>
			{hideFlag ? (
				<Select
					defaultValue={flag}
					className="browser-default custom-select code form-select"
					onChange={(val) => {
						const value = JSON.parse(val);
						Auth.setCurrency(value);
						setFlag(value.code);
						props.changeUserDefault &&
							setTimeout(async () => {
								handleChange();
							}, 50);
					}}
					loading={isLoading}
					bordered={false}>
					{currencies?.sort().map((currency, i) => {
						return (
							<Option value={JSON.stringify(currency)} key={i}>
								{currency.code}
							</Option>
						);
					})}
				</Select>
			) : (
				<>
					{isLoading || cloading ? (
						<span tw="ml-3">
							<Loading
								icon={
									<Loading3QuartersOutlined
										spin
										style={{ fontSize: 14 }}
									/>
								}
								tw="bg-white text-gray-500 rounded-full h-4! w-4!"
							/>
						</span>
					) : (
						<Select
							className="browser-default custom-select code form-select"
							defaultValue={
								<div tw="flex flex-row gap-1 items-center">
									<span
										role="img"
										aria-label={JSON.stringify(flag)}
										className="curreny-img"
										tw="flex items-center justify-center rounded-full">
										<CurrencyFlag
											currency={flag}
											width={30}
										/>
									</span>
									{flag}
								</div>
							}
							tw="w-full!"
							onChange={(val) => {
								const value = JSON.parse(val);
								console.log("select value", value.code);
								Auth.setCurrency(value);
								setFlag(value.code);
								props.changeUserDefault &&
									setTimeout(async () => {
										handleChange();
									}, 50);
							}}
							loading={isLoading}
							bordered={false}>
							{currencies?.sort().map((currency, i) => {
								return (
									<Option
										key={i}
										value={JSON.stringify(currency)}
										label={JSON.stringify(currency.code)}>
										<div tw="flex flex-row gap-1 items-center">
											<span
												role="img"
												aria-label={currency.code}
												className="curreny-img"
												tw="flex items-center justify-center rounded-full">
												<CurrencyFlag
													currency={currency.code}
													width={30}
												/>
											</span>
											{currency.code}
										</div>
									</Option>
								);
							})}
						</Select>
					)}
				</>
			)}
		</CurrencyWrapper>
	);
};

export default Currency;
